import { useContext } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import CreditPackages from './packages'
import Checkout from './checkout'
import WhiteLabelPackages from './white-label/packages'
import WhiteLabelCheckoutSuccess from './white-label/checkout/Success'
import AuthContext from '../../context/AuthContext'
import BrandingContext from '../../context/BrandingContext'

const Credits = () => {
  const [auth] = useContext(AuthContext)
  const [branding] = useContext(BrandingContext)

  const isWhiteLabelSubdealer =
    !branding.isTgt && auth.membership.dealer.id !== branding.masterDealerId

  return (
    <>
      {!isWhiteLabelSubdealer ? (
        <Switch>
          <Route path="/credits/packages" component={CreditPackages} />
          <Route path="/credits/checkout" component={Checkout} />
          <Redirect to="/credits/packages" />
        </Switch>
      ) : (
        <Switch>
          <Route path="/credits/packages" component={WhiteLabelPackages} />
          <Route
            path="/credits/checkout/success"
            component={WhiteLabelCheckoutSuccess}
          />
          <Redirect to="/credits/packages" />
        </Switch>
      )}
    </>
  )
}

export default Credits
